import { ServiceUtil } from './services.util'
import { SessionService, metadataService, FinancialService } from './';
import guid from '../utils/guid';
import { workflowConstants } from '../_constants';

export const newLoanService = {
    newLoan,
    newLoanByLeadId,
    getLeadDecision,
    validateState,
    saveUserBasisData,
    validatePreApprovalCode,
    sendNotificationEmail,
    getNewLoanRequestModel,
    getOnlineDisclosures,
    getLeapTheoryDecision,
    soldLeadLeapTheory,
};

export const LeadService = {
    newLoan,
    newLoanByLeadId,
    submitReferral, 
    submitChangeLoanRequest, 
    getNumberOfEarnedReferrals, 
    acknowledgeReferrals, 
    getPendingRequests, 
    getRecentRequests, 
    getMostRecentLead,
    isValidToken,
    getLeadById,
    sendIncompleteLead,
    LEAD_APPLIED : 5, 
    LEAD_APPROVED: 2, 
    LEAD_DECLINED: 3, 
    LEAD_NOCONTACT: 4 ,
    LEAD_WITHDRAWN: 6 ,
    LEADTYPE_REFERRAL : 9,
    LEADTYPE_REFINANCE_LOAN_REQUEST : 7,
    LEADTYPE_CREDIT_INCREASE_REQUEST : 8,
    LEADTYPE_NEW_LOAN_REQUEST : 2,
    LEADTYPE_NEW_LOAN_REQUEST_NEWUSER : 5,
    LEADTYPE_NEW_LOAN_REQUEST_EXISTINGUSER : 6,
    LEADTYPE_REFERRAL_ACKNOWLEDGEMENT : 3,
    LEADTYPE_PURCHASED_LEAD : 14,
    LEADTYPE_NEW_LOAN_REQUEST_PURCHASED_LEAD : 15,
    LEADTYPE_INCOMPLETE_LEAD : 17, 
    LEADTYPE_LEAPTHEORY_LEAD : 18,
}

function newLoan(data) {
    data.LeadType = 2; 
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/NewLoanRequest", ServiceUtil.putRequest(data));
}

function newLoanByLeadId(data) {
    data.LeadType = 15;
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/Update", ServiceUtil.postRequest(data));
}

function saveUserBasisData(data) { 
    return ServiceUtil.executeServiceCall("LeadAPI", "api/UserBasis/Save", ServiceUtil.postRequest(data));
}

function acknowledgeReferrals(){
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/AcknowledgeReferrals", ServiceUtil.getRequest());
}

function submitReferral(data) {
    data.LeadType = 9;
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/LoanReferral", ServiceUtil.putRequest(data));
}

function submitChangeLoanRequest(data)
{
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/ChangeLoanRequest", ServiceUtil.putRequest(data));
}

function getNumberOfEarnedReferrals(){
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/NumberOfEarnedReferrals", ServiceUtil.getRequest());
}

function getPendingRequests(){
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/PendingRequests", ServiceUtil.getRequest());
}

function getRecentRequests(){
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/Requests", ServiceUtil.getRequest());
}

function getMostRecentLead(){
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/MostRecentLead", ServiceUtil.getRequest());
}

function isValidToken(token) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/Token/IsValid/"+token, ServiceUtil.getRequest());
}

function getLeadById(leadId) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/GetLeadById/" + leadId, ServiceUtil.getRequest());
}

function validateState(state) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/ValidateState/" + state, ServiceUtil.getRequest());
}

function getOnlineDisclosures() {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/GetOnlineDisclosures", ServiceUtil.getRequest());
}

function validatePreApprovalCode(data) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/PreApproval", ServiceUtil.postRequest(data));
}

function sendNotificationEmail(data) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/SendNotificationEmail", ServiceUtil.postRequest(data));
//    return ServiceUtil.executeServiceCall("SendEmailNotificationFunction", "", ServiceUtil.postRequest(data));
}

function sendIncompleteLead(data) {
    data.LeadType = 17;
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/IncompleteLead", ServiceUtil.putRequest(data));
}

function getLeadDecision(userhash, leadid) {
    let data = { UserHash: userhash, LeadId: leadid };
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/GetLeadDecision", ServiceUtil.postRequest(data));
}

async function getLeapTheoryDecision(data) {
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/GetLeapTheoryDecision", ServiceUtil.postRequest(data));
}
function soldLeadLeapTheory(data) {
    data.LeadType = LeadService.LEADTYPE_LEAPTHEORY_LEAD;
    return ServiceUtil.executeServiceCall("LeadAPI", "api/Leads/SoldLeadLeapTheory", ServiceUtil.putRequest(data));
}


function getNewLoanRequestModel(workflowId) {
    const currentSession = SessionService.getSession();
    const {
        firstName,
        lastName,
        email,
        dateOfBirth,
        mobileNumber,
        alternateMobileNumber,
        address1,
        address2,
        city,
        state,
        postalCode,
        years,
        months,
        monthlyResidencePayment,
        socialSecurityNumber,
        individualTaxIdentificationNumber,
        preApprovalCode,
        userHash,
        mobilePhone,
        alternateMobilePhone,
        residenceType,
        addressId,
    } = currentSession.personalInfo;
    const {
        employers,
        incomes,
        fundingInformation,
    } = currentSession
    return {
        firstName: firstName,
        lastName: lastName,
        email: email,
        dateOfBirth: dateOfBirth,
        mobileNumber: mobileNumber ? mobileNumber : mobilePhone,
        alternateMobileNumber: alternateMobileNumber ? alternateMobileNumber : alternateMobilePhone ,
        branchId: fundingInformation.BranchId,
        fundDelivery: fundingInformation.FundDelivery, 
        personalIdentificationNumber: socialSecurityNumber ? socialSecurityNumber : individualTaxIdentificationNumber,
        personalIdentificationNumberIsITIN: individualTaxIdentificationNumber ? true : false,
        preApprovalCode: preApprovalCode,
        userHash: userHash,
        instantFunding :  fundingInformation.FundDelivery === metadataService.fundDeliveryType.Electronic && fundingInformation.InstantFunding != null ? fundingInformation.InstantFunding : null,
        employments : employers.filter(s=>s.isDelete != true).map(employer=> {
            const {                 
                primaryIncome,
                isAdd,
                employerName,
            } = employer
            return {
                ...employer,
                employerName: !employerName && primaryIncome ==
                FinancialService.PRIMARY_INCOME_SOURCE_SELFEMPLOYED ? metadataService.getLookupText("incomeSource",primaryIncome)
                : employerName,
                primaryIncomeSource : employer.primaryIncomeSource || primaryIncome,
                id : isAdd === true ? employer.id : guid(),
                lPXId : isAdd === true ? null : employer.id,
            };
        }),
        incomes : incomes.filter(s=>s.isDelete != true).map(income=>{
            const {
                otherIncomeSource,
                payFrequency,
                isAdd,
            } = income
            return {
                ...income,
                incomeSource : Number(otherIncomeSource),
                otherType : "",                 
                frequency : payFrequency || FinancialService.PAY_FREQUENCY_MONTHLY,
                id : isAdd === true ? income.id : guid(),
                lPXId : isAdd === true ? null : income.id,
            };
        }),
        addresses: [
            {
                address1: address1,
                address2: address2,
                city: city,
                state: state,
                postalCode: postalCode,
                ownResidence: Number(residenceType + "") === metadataService.ENUM_RESIDENCE_TYPE.OWN,
                years: workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW ? years == "" ? 0 : years : years,
                months: workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW ? months == "" ? 0 : months : months,
                monthlyResidencePayment: workflowId === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW ? monthlyResidencePayment == "" ? 0 : monthlyResidencePayment : monthlyResidencePayment, 
                residenceType : residenceType,
                lPXId : workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW ||  workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW  
                ?  addressId : null,
            }
        ]
    };
}


// WEBPACK FOOTER //
// ./src/_services/newloan.service.js